<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="'fa fa-life-ring text-danger'" class="mr-1"></i>
            {{ ticketspg.title }}
            <!-- {{ daterange }} -->
            <span v-if="eventcode"> for {{ eventtitle }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-if="!component" class="availtable datatable">
        <div class="px-3">
          <d-table
            classdivtable="availtable datatable"
            refid="ticketspg"
            :icon="ticketspg.icon"
            :toolbarlibrary="ticketspg.toolbarlibrary"
            :tools="ticketspg.tools"
            :badges="ticketspg.badges"
            :fields="ticketspg.fields"
            :items="ticketspg.items"
            :busy="ticketspg.busy"
            :page="ticketspg.page"
            :showpages="false"
            :showrowcount="false"
            @click="ticketspg_click"
            @select="ticketspg_select"
          >
          </d-table>
        </div>
      </div>
      <div v-if="component">
        <component
          :is="component"
          :selection="ticketspg.selected"
          :config="cconfig"
          @discard="ticketspg_click('discard')"
          @refresh="ticketspg_click('refresh')"
        ></component>
      </div>

      <b-card-footer class="mt-2">
        <b-row align-h="end">
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="8">
            <b-button
              squared
              size="sm"
              variant="secondary"
              class="mr-1"
              @click="discard"
            >
              <i class="fa fa-chevron-left pr-1"></i>Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

import TicketsBlackhole from "./TicketsBlackhole";
import TicketsRoutefix from "./TicketsRoutefix";
import TicketsInvoicing from "./TicketsInvoicing";

export default {
  name: "TicketsPG",
  components: {
    TicketsBlackhole,
    TicketsRoutefix,
    TicketsInvoicing,
  },
  watch: {
     selection: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          console.log("watch:selection", newVal);
          this.ticketspg.items = newVal
        }
      },
    },
  },
  data() {
    return {
      busy: false,
      readonly: false,
      issued_at: {
        startDate: this.$moment().startOf("month").format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },
      ticket: null,
      datetravel: null,
      ticketno: [],
      invoiceno: [],
      slac: [],
      slaclike: null,
      slaclike_visible: null,
      passenger: null,
      line_ri: null,
      emptyri: null,
      routing: null,
      classid: null,
      locator: [],
      eventcode: null,
      agent: null,
      flightno: null,
      type: [],
      fare_type: [],
      branch: [],
      state: [],
      options_state: [
        { id: "errors", label: "Errors" },
        { id: "warnings", label: "Warnings" },
      ],
      // iserror: null,
      isqueued: null,
      isinvoiced: null,
      isrelated: false,
      isvendorlocator: false,
      islive: true,
      ticketspg: {
        title: "Old Tickets Rescue",
        icon: "fa fa-ticket text-primary",
        debounce: 500,
        busy: false,
        page: 1,
        denied: [],
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-circle-o text-secondary",
            permission: "blackhole",
            position: "toolbar",
            action: "blackhole",
            label: "Black hole",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-location-arrow text-primary",
            position: "toolbar",
            action: "routefix",
            label: "Route fix",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-gbp text-primary",
            position: "toolbar",
            action: "inledgers",
            label: "Invoicing",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-ambulance text-primary",
            position: "toolbar",
            action: "charterfix",
            label: "Charter fix",
            component: {
              name: "",
            },
          },
        ],
        tools: "gopostgres,blackhole,routefix,inledgers,charterfix",
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-50px",
          },
          {
            key: "dateissued",
            label: "Date Issued",
            sortable: true,
            class: "text-center",
          },
          {
            key: "type",
            label: "Type",
            sortable: true,
            class: "text-center",
          },
          {
            key: "locator",
            label: "Locator",
            sortable: true,
            class: "text-center",
          },
          {
            key: "carrier_id",
            label: "Al",
            sortable: true,
            class: "text-center",
          },

          {
            key: "ticketno",
            label: "Ticket No",
            sortable: true,
            class: "text-center",
          },
          {
            key: "surname",
            label: "Last Name",
            sortable: true,
            class: "d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 20) {
                  result = result.slice(0, 17) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "datetravel",
            label: "Date Travel",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = value.split(" ")[0];
              }
              return result;
            },
          },
          {
            key: "routing",
            label: "Routing",
            sortable: true,
            class: "text-center",
          },
          {
            key: "flightno",
            label: "FlightNo",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 14) {
                  result = result.slice(0, 14) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "class",
            label: "Class",
            sortable: true,
            class: "text-center",
          },
          {
            key: "seatno",
            label: "Seat",
            sortable: true,
            class: "text-center",
          },
          // {
          //   key: "fare_type",
          //   label: "Fare Type",
          //   sortable: true,
          //   class: "text-center",
          // },
          {
            key: "fare",
            label: "Fare",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
          },
          {
            key: "tax",
            label: "Tax",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "text-center",
          },
          {
            key: "eventcode",
            label: "Event",
            sortable: true,
            class: "text-center",
          },
          {
            key: "branch",
            label: "Branch",
            sortable: true,
          },
          {
            key: "agent",
            label: "Agent",
            sortable: true,
          },
          {
            key: "invoiceno",
            label: "InvoiceNo",
            sortable: true,
            class: "text-center",
          },
          {
            key: "lines",
            label: "#Sec",
            sortable: true,
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [
          {
            key: "carrier_id",
            type: "pill",
            class: "white",
          },
          {
            key: "ticketno",
            type: "pill",
            class: "orange",
          },
          {
            key: "class",
            type: "pill",
            class: "purple",
            title: "classname",
          },
          {
            key: "locator",
            type: "pill",
            class: "secondary",
          },
          {
            key: "lines",
            type: "pill",
            class: "white",
          },
          {
            key: "type",
            type: "badge",
            Charter: "primary",
            Ticket: "primary",
            Reissue: "primary",
            Void: "white",
            Refund: "white",
            EMD: "purple",
          },
          {
            key: "fare_type",
            type: "badge",
            Unknown: "white",
            Negotiated: "warning",
            Net: "purple",
            Manual: "secondary",
            Published: "white",
            Private: "pink",
            other: "secondary",
            formatter: (value, key, item) => {
              switch (parseInt(value)) {
                case "Unknown":
                  return "Unknown";
                  break;
                case "Negotiated":
                  return "Negotiated";
                  break;
                case "Net":
                  return "Net";
                  break;
                case "Manual":
                  return "Manual";
                  break;
                case "Published":
                  return "Published";
                  break;
                case "Private":
                  return "Private";
                  break;
                default:
                  return value;
              }
            },
          },
          {
            key: "queued",
            type: "badge",
            Yes: "danger",
            No: "info",
            formatter: (value, key, item) => {
              if (value == true) {
                return "Yes";
              } else if (value == false) {
                return "No";
              } else {
                return "";
              }
            },
          },
        ],
        items: [],
        selected: [],
      },
    };
  },
  methods: {
    accessdenied() {
      this.ticketspg.denied = [];
      //   if (!this.user.permissions.includes("tickets.pnrsync")) {
      //     this.ticketspg.denied.push("sync");
      //     this.ticketspg.denied.push("errors");
      //   }
      //   if (!this.user.permissions.includes("tickets.blackhole")) {
      //     this.ticketsrepository.denied.push("blackhole");
      //     this.ticketsrepository.denied.push("inledgers");
      //     this.ticketsrepository.denied.push("routefix");
      //     this.ticketsrepository.denied.push("charterfix");
      //   }

      //   if (!this.user.permissions.includes("tickets.delete")) {
      //     this.ticketsrepository.denied.push("delete");
      //   }
      //   if (!this.user.permissions.includes("tickets.save")) {
      //     this.ticketsrepository.denied.push("save");
      //   }
    },

    async ticketspg_click(a, ss) {

      switch (a) {
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
        case "refresh":
        case "go":
          this.component = null;
          //   this.dateSelector();
          this.load();
          break;

        case "edit":
          this.component = "TicketEdit";
          break;
        case "sync":
          this.component = "TicketsSync";
          break;
        case "errors":
          this.component = "TicketsErrors";
          break;
        case "blackhole":
          this.component = "TicketsBlackhole";
          break;
        case "routefix":
          this.component = "TicketsRoutefix";
          break;
        // case "notes":
        //   this.component = "TicketNotes";
        //   break;
        case "inledgers":
          this.component = "TicketsInvoicing";
          break;
        case "charterfix":
          this.charterfixit(ss);
          break;
        case "etrview":
          this.component = "ETRView";
          break;
        case "etremail":
          this.component = "ETREmail";
          break;

        case "invoice":
          if (ss.length > 0) {
            if (ss[0].invoiceno) {
              this.component = "TicketsInvoice";
            } else {
              this.component = null;
            }
          }

          break;
        case "delete":
          this.deleteit(ss);
          break;
      }
    },
    async ticketspg_select(ss, tools) {
      console.log("ticketspg_select", ss);

      let state = this.ticketspg;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = [
          "back",
          "save",
          "go",
          "filter",
          "add",
          "export",
          "sync",
          "blackhole",
          "routefix",
          "inledgers",
          "charterfix",
        ];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit", "notes", "etrview", "invoice"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm", "errors", "etremail"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },
    async charterfixit() {
      this.busy = true;

      let variables = {
        apply: true,
      };
      console.log("charterfix variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query tickets_charterfix($apply: Boolean) {
              tickets_charterfix(apply: $apply)
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async deleteit(s) {
      console.log("deleteit", s);

      let rows = [];
      s.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation tickets_delete($rows: [Ticket_input]) {
              tickets_delete(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.load();
    },
    async downloadit() {
      this.busy = true;

      let variables = {
        selected: this.$helpers.prepareforSave(this.selection),
        isgroupetr: this.isgroupetr,
        showseatno: true,
        documentformat: this.documentformat,
        dateformat: "YYYY-MM-DD",
      };
      console.log("download variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query tickets(
              $selected: [Ticket_input]
              $isgroupetr: Boolean
              $showseatno: Boolean
              $documentformat: String
              $dateformat: String
            ) {
              tickets(
                selected: $selected
                isgroupetr: $isgroupetr
                showseatno: $showseatno
                documentformat: $documentformat
                dateformat: $dateformat
              ) {
                documentname
                documentpdf
              }
            }
          `,
          variables,
        });
        if (response.data.tickets.length > 0) {
          try {
            this.fileUpload = JSON.parse(response.data.tickets[0].data);
          } catch (error) {
            // this.fileUpload = {
            //   name: response.data.orders[0].yourref + ".pdf",
            //   data: response.data.orders[0].data,
            // };
          }
          await this.fileUpload_view();
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
  },
};
</script>
